import { Home } from '@mui/icons-material';
import { Alert, Box, Button } from '@mui/material';

function ChatEncerradoAlert({ mensagem = 'O chat foi encerrado por inatividade.' }) {
  const handleVoltar = () => {
    // 🔥 Limpa o histórico local
    localStorage.removeItem('chatHistory');
    // console.log('🗑️ Histórico de mensagens removido ao voltar para tela inicial.');

    // Recarrega para forçar volta à tela inicial
    window.location.reload();
  };

  return (
    <Alert
      variant="filled"
      severity="error"
      sx={{
        borderRadius: '0px 0px 28px 28px',
        boxShadow: 1,
        p: 1.0,
        m: 'auto',
        justifyContent: 'center',
        textAlign: 'center',
        '& .MuiAlert-icon': {
          display: 'none',
        },
      }}
    >
      <Box>
        <p>{mensagem}</p>
        <p>Para iniciar um novo atendimento, volte à tela inicial.</p>
        <Button
          onClick={handleVoltar}
          variant="contained"
          color="error"
          startIcon={<Home />}
          sx={{
            marginTop: '8px',
            padding: '3px 10px',
            fontSize: '0.88rem',
            borderRadius: '12px',
            border: '1px solid white',
            color: 'white',
            minWidth: '100px',
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none',
            },
          }}
        >
          Voltar
        </Button>
      </Box>
    </Alert>
  );
}

export default ChatEncerradoAlert;
